/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SalesFilterRequest { 
    publicationDateFrom?: number;
    publicationDateTo?: number;
    createdAtFrom?: number;
    createdAtTo?: number;
    trusteeIds?: Array<string>;
    debtorIds?: Array<string>;
    types?: Array<SalesFilterRequest.TypesEnum>;
    location?: string;
}
export namespace SalesFilterRequest {
    export type TypesEnum = 'REAL_ESTATE' | 'MOVABLE_PROPERTY' | 'REAL_MOVABLE' | 'BUILDABLE_LAND' | 'LEASE_RENTAL' | 'AMENDMENT' | 'CANCELLATION';
    export const TypesEnum = {
        REALESTATE: 'REAL_ESTATE' as TypesEnum,
        MOVABLEPROPERTY: 'MOVABLE_PROPERTY' as TypesEnum,
        REALMOVABLE: 'REAL_MOVABLE' as TypesEnum,
        BUILDABLELAND: 'BUILDABLE_LAND' as TypesEnum,
        LEASERENTAL: 'LEASE_RENTAL' as TypesEnum,
        AMENDMENT: 'AMENDMENT' as TypesEnum,
        CANCELLATION: 'CANCELLATION' as TypesEnum
    };
}